export const MAX_DESCRIPTION_LENGTH = 160
